export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_03.549bb6af.jpg";